module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "tenmo-money-transfers.ab953f30.png" + "?" + Date.now();